<template>
  <div>
    <table class="table table-sm table-hover">
      <thead>
      <tr>
        <th></th>
        <th>Препарат</th>
        <th>Количество</th>
        <template>
          <th v-for="supp in suppliers">
            <span class="badge badge-dark pointer" v-tooltip='supp.title'>{{ supp.title[0] }}</span>
          </th>
        </template>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(record, i) in records">
        <td>{{ i + 1 }}</td>
        <td>
          <DrugTitleView :drug="record.drug"/>
        </td>
        <td>
          {{ +record.qty }}
        </td>
        <template>
          <td v-for="supp in suppliers">
            <div v-if="record.price_data && record.price_data.prices && record.price_data.prices[supp.id]">
              <p>{{ record.price_data.prices[supp.id].price }}
                <a :href="`https://${record.price_data.prices[supp.id].priceUrl}`" target="_blank"><i
                  class="icon-fa icon-fa-external-link"/></a></p>
            </div>
          </td>
        </template>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import DrugTitleView from "@/components/drugs/DrugTitleView";

export default {
  props: ['records', 'suppliers'],
  components: {
    DrugTitleView
  },
  data() {
    return {}
  }
}

</script>
